import { render, staticRenderFns } from "./comDtoSide1.vue?vue&type=template&id=d750411a&scoped=true&"
import script from "./comDtoSide1.vue?vue&type=script&lang=js&"
export * from "./comDtoSide1.vue?vue&type=script&lang=js&"
import style0 from "./comDtoSide1.vue?vue&type=style&index=0&id=d750411a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d750411a",
  null
  
)

export default component.exports